export default {"src":"https://assets.willie.be/c0aaa858cfc53493/_next/static/media/favicon.1a012642.ico","height":16,"width":16,"blurWidth":0,"blurHeight":0};